<template>
  <div id="home" v-on:scroll="scrollHandler">
    <div id="main-section">
      <div class="slider-wrapper" v-on:wheel="MouseWheelHandler">
        <div id="slide-1" class="position-relative bg-img-atr trans-1000-ms" v-bind:style="{ transform: 'translateY(' + getSlideOffSetY + ')' }">
          <div class="overlay-bg-lightdark overlay position-absolute">
            <div class="container container-flex-center position-relative">
              <div class="col-sm-12" style="width: 100%">
                <div class="headline-container text-center">
                  <h1 class="white-color pre-formatted" v-scrollanimation>{{dataText.slideOne.title}}</h1>
                </div>
              </div>
              <div class="scroll-more-container position-absolute">
                <div class="scroll-more-wrapper-btn text-center">
                  <a href="#slide-2" class="white-color">{{dataText.slideOne.subTitle}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="slide-2" class="position-relative trans-1000-ms blue-bg" v-bind:style="{ transform: 'translateY(' + getSlideOffSetY + ')' }">
          <div class="container-fluid container-flex-center position-relative">
            <div class="col-lg-12">
              <div class="slide-text-container text-justify">
                <h2 v-scrollanimation class="white-color">{{dataText.slideTwo.title}}</h2>
              </div>
            </div>
            <div class="scroll-more-container position-absolute">
              <div class="scroll-more-wrapper-btn text-center">
                <a href="#slide-3" class="white-color">{{dataText.slideTwo.subTitle}}</a>
              </div>
            </div>
            <div class="position-absolute home-goto-btn trans-300-ms">
              <router-link to="about">
                <svg v-scrollanimation class="bi bi-chevron-double-right" width="1em" height="1em" viewBox="0 0 16 16" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"/>
                  <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </router-link>
            </div>
          </div>
        </div>
        <div id="slide-3" class="position-relative bg-img-atr trans-1000-ms" v-bind:style="{ transform: 'translateY(' + getSlideOffSetY + ')' }">
          <div class="overlay overlay-bg-light position-absolute">
            <div class="container container-flex-center position-relative" style="padding: 0;">
              <div class="column-inner" style="width: 100%;">
                <div class="wrapper">
                  <div class="col-md-4 col-display" v-for="(card, index) in dataText.slideThree.cards" v-bind:key="index" v-scrollanimation>
                    <div class="column-inner">
                      <div class="wrapper">
                        <div class="card trans-300-ms">
                          <div class="card-body d-flex align-items-center justify-content-center">
                            <img :src="card.icon" alt="H3 Usluge ikonica" style="height: auto;">
                          </div>
                          <div class="card-body text-center">
                            <h5>{{card.title}}</h5>
                            <ul>
                              <li v-for="(item, index) in card.services" v-bind:key="index">{{item}}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 scroll-more-container position-absolute">
                <div class="scroll-more-wrapper-btn text-center">
                  <a href="#slide-4" class="black-color">{{dataText.slideThree.subTitle}}</a>
                </div>
              </div>
            </div>
            <div class="position-absolute home-goto-btn trans-300-ms">
              <router-link to="services">
                <svg v-scrollanimation class="bi bi-chevron-double-right" width="1em" height="1em" viewBox="0 0 16 16" fill="#0C0C0C" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"/>
                  <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </router-link>
            </div>
          </div>
        </div>
        <div id="slide-4" class="position-relative bg-img-atr trans-1000-ms" v-bind:style="{ transform: 'translateY(' + getSlideOffSetY + ')' }">
          <div class="overlay overlay-bg-lightdark position-absolute">
            <div class="container container-flex-center position-relative">
              <div class="col-sm-12">
                <div class="column-inner">
                  <div class="wrapper">
                    <div class="slide-text-container text-justify">
                      <h1 v-scrollanimation class="white-color">{{dataText.slideFour.title}}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="position-absolute home-goto-btn trans-300-ms">
              <router-link to="blog">
                <svg v-scrollanimation class="bi bi-chevron-double-right" width="1em" height="1em" viewBox="0 0 16 16" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"/>
                  <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed bullet-pagination-container">
        <a id="a-tag-1" href="#" @click="clickSlideOffSet(1)"><span class="position-relative text-center pagination-bullet" data-label="Intro"></span></a>
        <a id="a-tag-2" href="#" @click="clickSlideOffSet(2)"><span class="position-relative text-center pagination-bullet" data-label="O nama"></span></a>
        <a id="a-tag-3" href="#" @click="clickSlideOffSet(3)"><span class="position-relative text-center pagination-bullet" data-label="Usluge"></span></a>
        <a id="a-tag-4" href="#" @click="clickSlideOffSet(4)"><span class="position-relative text-center pagination-bullet" data-label="Blog"></span></a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  props: {
    webData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      slides: [],
      dataText: this.webData.home,
      currSlide: null,
      animationOnGoing: false,
      transitionIsActive: false,
      slideTo: '',
      parentDot: null,
    }
  },
  mounted() {
    this.getElOffset();
  },
  methods: {
    getElOffset: function () {
      this.slides = [{id: '1'}, {id: '2'}, {id: '3'}, {id: '4'}];
      this.slides[0].offsetTop = Number(document.querySelector('#slide-1').offsetTop);
      this.slides[1].offsetTop = Number(document.querySelector('#slide-2').offsetTop);
      this.slides[2].offsetTop = Number(document.querySelector('#slide-3').offsetTop);
      this.slides[3].offsetTop = Number(document.querySelector('#slide-4').offsetTop);
      this.currSlide = this.slides[0];
    },
    scrollHandler : function ($event) {
      if (!this.animationOnGoing && this.currSlide) {
        let half = this.wH / 2;
        let e = null;
        let n = Number(this.currSlide.id);
        try {
          e = $event.target.scrollTop;
        } catch {
          e = $event.path[0].scrollTop;
        }
        if (this.currSlide === 'undefined') return;
        else if (n > 1 && e <= half) this.clickSlideOffSet(0);
        else if (n > 2 || n < 2 && e >= half && e < half * 3) this.clickSlideOffSet(1);
        else if (n < 3 && e >= half * 3) this.clickSlideOffSet(2);
      }
    },
    MouseWheelHandler (e) {
      // cross browser wheel delta
      //e = window.event || e; //old IE support
      e.preventDefault();
      if (!this.animationOnGoing) {
        this.setAnim(true);
        this.scrollTo(e);
      }
    },
    scrollTo : function (e) {
      let parentEl = this.currSlide;
      let s = null;
      let delta_fox = null;
      let delta = Math.max(-1, Math.min(1, (e.wheelDelta || e.wheelDeltaY)));
      if (delta.toString() === 'NaN' || delta.toString() === 'Undefined') {
        delta_fox = Math.max(-1, Math.min(1, (e.deltaY)));
      }
      if (delta === -1 || delta_fox === 1) {
        if (parentEl.id === '4') {
          this.setAnim(false);
          return;
        } else {
          s = parentEl.id;
          this.setSlideOffSet(s);
        }
      }
      else if (delta === 1 || delta_fox === -1) {
        if (parentEl.id === '1') {
          this.setAnim(false);
        } else {
          this.navColorIsActive = false;
          s = Number(parentEl.id) - 2;
          this.setSlideOffSet(s);
        }
      }
      else if (delta === 0 || delta_fox === 0) {
        this.setAnim(false);
      }
    },
    setAnim : function (state) {
      if (state === false) {
        //this.scrollLineAnimation();
      }
      this.animationOnGoing = state;
    },
    setSlideOffSet : function (slide) {
      console.log('id: ', this.currSlide.id);
      this.currSlide = this.slides[slide];
      this.slideTo = "-" + this.currSlide.offsetTop + "px";
      if (this.currSlide.id === '2') {
        console.log('here');
        this.$emit('logoColorChange', true);
      }
      else  this.$emit('logoColorChange', false);
      setTimeout(() => {
        this.setAnim(false);
      }, 1000);
    },
    clickSlideOffSet : function (slide) {
      if (Number(this.currSlide.id) - 1 === slide) return;
      else {
        this.setAnim(true);
        this.setSlideOffSet(slide)
      }
    },
    /*
    scrollLineAnimation: function () {
      let elPrev = this.parentLine;
      let elCurr = null;
      if (this.currSlide.id === '1') {
        elCurr = document.querySelector('#line-1');
        this.navColorIsActive = false;
      } else if (this.currSlide.id === '2') {
        elCurr = document.querySelector('#line-2');
        this.navColorIsActive = false;
      } else {
        elCurr = document.querySelector('#line-3');
        document.querySelector('#ncvl-lc-bb').style.borderBottomColor = '#ffffff';
        this.navColorIsActive = true;
      }
      elCurr.style.width = '2px';
      elCurr.style.height = '200px';
      if (elPrev !== null && this.slideLineState === false) {
        elPrev.style.height = '1px';
        elPrev.style.width = '1px';
        if (this.currSlide.id !== '3') {
          document.querySelector('#ncvl-lc-bb').style.borderBottomColor = 'transparent';
        }
      }
      this.parentLine = elCurr;
      this.slideLineState = false;
    }
     */
  },
  computed: {
    getSlideOffSetY: function () {
      return this.slideTo;
    }
  }

}
</script>

<style>
  /******************************************/
  /*            TRANSITION                 */
  /****************************************/
  .trans-300-ms {
    transition: 300ms ease-in-out;
  }
  .trans-500-ms {
    transition: 500ms ease-in-out;
  }
  .trans-1000-ms {
    transition: 1000ms ease-in-out;
  }

  /******************************************/
  /*            ATTRIBUTES                 */
  /****************************************/
  .bg-img-atr, .bg-img-atr-fix {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .bg-img-atr-fix {
    background-attachment: fixed;
  }
  .pre-formatted {
    white-space: pre-line;
  }
  .nowrap-formatted {
    white-space: nowrap;
  }

  /******************************************/
  /*              COLORS                   */
  /****************************************/
  .white-color {
    color: #fff;
  }
  .black-color {
    color: #0C0C0C;
  }
  .blue-bg {
    background-color: #5666AE;
  }
  .white-bg {
    background-color: #fff;
  }
  .gray-bg {
    background-color: #ececec;
  }
  .black-bg {
    background-color: #0C0C0C;
  }

  /******************************************/
  /*            ELEMENTS                   */
  /****************************************/
  .page-header {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    border: none;
    box-shadow: none;
  }
  .row-block {
    display: block;
    margin: 0;
  }
  .overlay {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 5;
  }
  .overlay-bg-lightdark {
    background-color: rgba(0, 0, 0, .328);
  }
  .overlay-bg-light {
    background-color: rgba(255, 255, 255, .373);
  }
  .bullet-pagination-container {
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    z-index: 10;
  }
  .pagination-bullet {
    margin: 10px 0;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    background-color: #fff;
    opacity: .2;
    cursor: pointer;
    display: block;
  }
  .pagination-bullet:after {
    content: attr(data-label);
    position: absolute;
    right: 20px;
    top: -8px;
    min-width: 120px;
    text-align: center;
    color: #fff;
    background-color: #222;
    padding: 2px 8px;
    border-radius: 20px;
    opacity: 0;
    transition: opacity .2s ease-in-out, transform .25s ease-in-out;
    cursor: pointer;
  }

  /*********************/
  /*      SLIDES      */
  #main-section {
    height: 100vh;
    overflow-y: hidden;
  }
  .slider-wrapper {
    height: auto;
    display: flex;
    align-items: normal;
    flex-direction: column;
  }
  #slide-1, #slide-2, #slide-3, #slide-4 {
    height: 100vh;
  }
  #slide-1 {
    background-image: url("../assets/photos/bg01.webp");
  }
  #slide-3 {
    background-image: url("../assets/photos/bg02.webp");
  }
  #slide-4 {
    background-image: url("../assets/photos/bg03.webp");
  }
  .container-flex-center {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .headline-container {
    margin: 0 auto;
    width: auto;
    text-transform: uppercase;
  }
  .slide-text-container {
    width: inherit;
  }
  .scroll-more-container {
    width: 100%;
    bottom: 35px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .scroll-more-wrapper-btn {
    width: 315px;
    height: 40px;
    padding: 5px 50px;
    margin: 0 auto;
    background-color: transparent;
    border: 2px solid #cecece;
  }
  .scroll-more-wrapper-btn a {
    font-size: 16px;
    letter-spacing: 2px;
  }
  #slide-3 .scroll-more-wrapper-btn {
    width: 365px;
    border: 2px solid #0C0C0C;
  }
  .scroll-more-wrapper-btn p {
    font-size: 16px;
    margin-bottom: 0;
  }
  /*********************/
  /*      SPACER      */
  .spacer-sm {
    height: 20px;
  }
  .spacer-md {
   height: 40px;
  }
  /*********************/
  /*      CARDS       */
  .card-body h5 {
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 20px;
  }
  #slide-3 .card {
    background-color: rgba(255, 255, 255, .558);
    border: 1px solid #5666AE;
    box-shadow: 0 0 20px 3px #9d9d9d;
  }
  #slide-3 .card:hover {
    background-color: #ffffff;
  }
  /*********************/
  /*     Button       */
  .home-goto-btn {
    background: transparent;
    border: 1px solid transparent;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  /******************************************/
  /*            ANIMATION                  */
  /****************************************/
  .before-enter {
    opacity: 0;
    transform: translateY(180px);
    transition: all 800ms ease-out;
  }
  .enter {
    opacity: 1;
    transform: translateY(0px);
    transition-delay: 500ms;
  }
</style>
